<template>
  <div class="profile">
    <div class="profile-container">
      <h1 class="profile-text">Профиль</h1>
      <section class="profile-info">
        <div class="profile-info__login">
          <p class="profile-info__login-head">Логин</p>
          <h3 class="profile-info__login-login">{{ this.name }}</h3>
        </div>
      </section>
      <section class="profile-info__bonus-section">
        <div class="profile-info__bonus">
          <p class="profile-info__bonus-head">Бонусная программа</p>
          <div class="profile-info__bonus-info">
            <h3 class="profile-info__bonus-info__score">
              Бонусные баллы: {{ this.scores.Value }}
            </h3>
          </div>
          <div class="profile-info__titles">
            <div class="profile-info__titles-status">Статус</div>
            <div class="profile-info__titles-cashback">Кешбэк</div>
          </div>
          <div class="profile-info__bonus-bar">
            <div class="profile-info__bonus-bar__wrapper">
              <div class="profile-info__bonus-bar__separator">
                <div class="profile-info__bonus-bar__marker filled__blue"></div>
                <div
                  class="profile-info__bonus-bar__connector"
                  :style="firstConnectorStyle"
                ></div>
              </div>
              <div class="profile-info__bonus-bar__content">
                <div
                  class="profile-info__bonus-bar__content-title"
                  :class="{ 'active-status': firstStatus }"
                >
                  Первооткрыватель
                </div>
                <div class="profile-info__bonus-bar__content-info"></div>
              </div>
              <div
                class="profile-info__bonus-bar__cashback"
                :class="{ 'active-status': firstStatus }"
              >
                0,5%
              </div>
            </div>
            <div class="profile-info__bonus-bar__wrapper">
              <div class="profile-info__bonus-bar__separator">
                <div
                  class="profile-info__bonus-bar__marker"
                  :class="{ filled__blue: secondMeter }"
                ></div>
                <div
                  class="profile-info__bonus-bar__connector"
                  :style="secondConnectorStyle"
                ></div>
              </div>
              <div class="profile-info__bonus-bar__content">
                <div
                  class="profile-info__bonus-bar__content-title"
                  :class="{ 'active-status': secondStatus }"
                >
                  Путешественник
                </div>
                <div class="profile-info__bonus-bar__content-info">
                  От 350 баллов
                </div>
              </div>
              <div
                class="profile-info__bonus-bar__cashback"
                :class="{ 'active-status': secondStatus }"
              >
                0,75%
              </div>
            </div>
            <div class="profile-info__bonus-bar__wrapper">
              <div class="profile-info__bonus-bar__separator">
                <div
                  class="profile-info__bonus-bar__marker"
                  :class="{ filled__blue: thirdMeter }"
                ></div>
              </div>
              <div class="profile-info__bonus-bar__content">
                <div
                  class="profile-info__bonus-bar__content-title"
                  :class="{ 'active-status': thirdStatus }"
                >
                  Я - Легенда
                </div>
                <div class="profile-info__bonus-bar__content-info">
                  От 999 баллов
                </div>
              </div>
              <div
                class="profile-info__bonus-bar__cashback"
                :class="{ 'active-status': thirdStatus }"
              >
                1%
              </div>
            </div>
          </div>
          <div class="profile-info__bonus-desc">
            <a
              href="https://www.biletdv.ru/Pages/Bonusnaya-Programma"
              class="profile-info__bonus-desc__link"
              >Описание бонусной программы</a
            >
            <div class="profile-info__bonus-desc__icon">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M10.7984 5.96286H9.95085C9.77533 5.96286 9.63303 6.10515 9.63303 6.28068V10.1448C9.63303 10.3499 9.46611 10.5168 9.26101 10.5168H1.85547C1.65042 10.5168 1.48362 10.3499 1.48362 10.1448V2.73938C1.48362 2.53424 1.65042 2.36732 1.85547 2.36732H5.91744C6.09296 2.36732 6.23526 2.22502 6.23526 2.0495V1.20198C6.23526 1.02645 6.09296 0.884155 5.91744 0.884155H1.85547C0.832599 0.884155 0.000457764 1.71642 0.000457764 2.73938V10.1448C0.000457764 11.1678 0.832641 12 1.85547 12H9.26096C10.2839 12 11.1162 11.1678 11.1162 10.1448V6.28072C11.1162 6.10515 10.9739 5.96286 10.7984 5.96286Z"
                    fill="#4D4A4B"
                  />
                  <path
                    d="M11.6821 0H8.31099C8.13546 0 7.99317 0.142299 7.99317 0.317821V1.16534C7.99317 1.34087 8.13546 1.48317 8.31099 1.48317H9.46803L5.11409 5.83702C4.98997 5.96114 4.98997 6.16234 5.11409 6.28651L5.71337 6.88583C5.77299 6.94545 5.8538 6.97893 5.93813 6.97893C6.02242 6.97893 6.10327 6.94545 6.16285 6.88583L10.5168 2.53189V3.68889C10.5168 3.86441 10.6591 4.00671 10.8346 4.00671H11.6821C11.8577 4.00671 12 3.86441 12 3.68889V0.317821C12 0.142299 11.8577 0 11.6821 0Z"
                    fill="#4D4A4B"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </section>
      <section class="profile-subscribe">
        <p class="profile-subscribe__text">Подписки</p>
        <form
          action=""
          class="profile-subscribe__form"
          @submit.prevent="subscribing"
        >
          <label>
            <div class="profile-subscribe__form-wrapper">
              <h3 class="profile-subscribe__form-text">
                Новости и рекламные материалы
              </h3>
              <input
                type="checkbox"
                name="subscribe"
                class="profile-subscribe__form-check"
                v-model="this.checked"
              />
            </div>
          </label>
          <!-- <div class="p-ripple profile-subscribe__form-btn" v-ripple> -->
          <Button
            @click="subscribing"
            class="profile-subscribe__form-btn__submit"
            label="Сохранить"
          />
          <!-- </div> -->
        </form>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/runtime-core";
import axios from "axios";
import Button from "primevue/button";
import Ripple from "primevue/ripple";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "Profile",
  components: {
    Button,
    Toast
  },
  setup() {
    const toast = useToast();
      const showSuccess = () => {
        toast.add({
          severity: "success",
          summary: "Выполнено!",
          detail: "Обращение обновлено",
          life: 3000,
        });
      };
    function getSubscribeInfo() {
      const roles = sessionStorage.getItem("roles");
      if (roles !== null && roles.includes("Subscribers")) {
        return true;
      } else {
        return false;
      }
    }
    function getUserData() {
      const data = sessionStorage.getItem("userInfo");
      if (data !== null) {
        return JSON.parse(data);
      }
    }
    function getUserName() {
      const data = sessionStorage.getItem("userName");
      if (data !== null) {
        return JSON.parse(data);
      }
    }

    return {
      getUserData,
      getUserName,
      getSubscribeInfo,
      showSuccess,
      toast
    };
  },

  data() {
    return {
      isSubscribed: this.getSubscribeInfo(),
      checked: this.getSubscribeInfo(),
      scores: this.getUserData(),
      name: this.getUserName(),
    };
  },
  methods: {
    unSubscribe: async () => {
      try {
        const json = await axioCred.post(
          `https://www.biletdv.ru/customer/IBEServices/UnsubscribeFromNews`
        );
        let response = await json.data;
        sessionStorage.setItem("roles", JSON.stringify(response.Roles));
        console.log(response);
      } catch (err) {
        console.log(err);
      }
    },
    subscribe: async () => {
      try {
        const json = await axioCred.post(
          `https://www.biletdv.ru/customer/IBEServices/SubscribeForNews`
        );
        let response = await json.data;
        sessionStorage.setItem("roles", JSON.stringify(response.Roles));
        console.log(response);
      } catch (err) {
        console.log(err);
      }
    },
    subscribing() {
      if (this.isSubscribed && !this.checked) {
        this.unSubscribe();
        this.isSubscribed = false;
      } else if (!this.isSubscribed && this.checked) {
        this.subscribe();
        this.isSubscribed = true;
      }
    },
  },
  directives: {
    ripple: Ripple,
  },
  computed: {
    //BonusProgram progress bar
    firstMeter(): number {
      if ((this.scores.Value / 350) * 100 >= 100) {
        return 100;
      } else {
        return (this.scores.Value / 350) * 100;
      }
    },
    secondMeter(): number {
      if (this.scores.Value < 350) {
        return 0;
      } else if ((this.scores.Value / 1000) * 100 >= 100) {
        return 100;
      } else {
        return (this.scores.Value / 1000) * 100;
      }
    },
    thirdMeter(): number {
      if (this.scores.Value < 1000) {
        return 0;
      } else if ((this.scores.Value / 3000) * 100 >= 100) {
        return 100;
      } else {
        return (this.scores.Value / 3000) * 100;
      }
    },

    firstStatus(): any {
      if (this.secondMeter <= 0 && this.thirdMeter <= 0) {
        return true;
      } else {
        return false;
      }
    },
    secondStatus(): any {
      if (this.secondMeter > 0 && this.thirdMeter == 0) {
        return true;
      } else {
        return false;
      }
    },
    thirdStatus(): any {
      if (this.thirdMeter > 0) {
        return true;
      } else {
        return false;
      }
    },
    firstConnectorStyle(): any {
      if (this.firstStatus || this.secondStatus || this.thirdStatus) {
        return `background: linear-gradient(180deg, #289dcc ${
          this.firstMeter + "%"
        }, #dfdfdf 10%)`;
      } else {
        return `background: #dfdfdf`;
      }
    },

    secondConnectorStyle(): any {
      if (this.secondStatus || this.thirdStatus) {
        return `background: linear-gradient(180deg, #289dcc ${
          this.secondMeter + "%"
        }, #dfdfdf 10%)`;
      } else {
        return `background: #dfdfdf`;
      }
    },
    //End of code for bonusProgram progress bar
  },
});
</script>

<style>
@media screen and (max-width: 1024px) {
  .sidebar-menu__comp {
    display: none;
  }

  .profile-text {
    margin-left: 20px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
  }

  .profile-info {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 18px;
    width: 100%;
    background: #ffffff;
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    padding-bottom: 15px;
  }

  .profile-info__login {
    margin: 10px 0 0 20px;
  }

  .profile-info__login-head {
    display: block;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 14px;
    color: #939090;
  }

  .profile-info__login-login {
    margin-top: 15px;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
  }

  .profile-info__bonus-section {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 18px;
    width: 100%;
    background: #ffffff;
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    padding-bottom: 15px;
  }

  .profile-info__bonus {
    margin: 10px 0 0 20px;
  }

  .profile-info__bonus-head {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 14px;
    color: #939090;
  }

  .profile-info__bonus-info {
    margin-top: 15px;
    margin-right: 15px;
    display: flex;
    justify-content: space-between;
  }

  .profile-info__bonus-info__score {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
  }

  .profile-info__bonus-info__status {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    color: #3d9c1c;
  }

  .profile-info__bonus-bar {
    margin: 20px 15px 0 0;
    min-height: 50px;
  }

  .profile-info__bonus-desc {
    display: flex;
    margin-top: 25px;
    align-items: center;
  }

  .profile-info__bonus-desc__link {
    text-decoration: none;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }

  .profile-info__bonus-desc__icon {
    margin: 0 0 0 5px;
  }

  .profile-subscribe {
    overflow: hidden;
    margin-top: 20px;
    background: #ffffff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
  }

  .profile-subscribe__text {
    display: block;
    margin: 14px 0 0 20px;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 14px;
    color: #939090;
  }

  .profile-subscribe__form {
    margin: 15px 0 0 20px;
  }
  .profile-subscribe__form-wrapper {
    display: flex;
    align-items: center;
  }

  .profile-subscribe__form-text {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
  }

  .profile-subscribe__form-check {
    margin: 2px 0 0 12px;
  }

  .profile-subscribe__form-btn__submit {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 14px;
    background-color: #2196f3;
    color: #ffffff;
    border: none;
    border-radius: 4px !important;
    padding: 6px 20px;
    overflow: hidden;
    margin: 15px 0 15px 0 !important;
  }

  .profile-info__bonus-bar__status {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    color: rgb(148, 148, 148);

    margin: 0 0 15px 0;
  }

  .profile-info__titles {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    margin-right: 20px;
  }

  .profile-info__titles-status {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
  }

  .profile-info__titles-cashback {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
  }

  .profile-info__bonus-bar__wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    min-height: 70px;
  }

  .profile-info__bonus-bar__separator {
    -webkit-box-flex: 0;
    -ms-flex: 0;
    flex: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .profile-info__bonus-bar__marker {
    border: 2px solid #2196f3;
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
    background-color: #ffffff;
  }

  .filled__blue {
    background-color: #2196f3;
  }

  .profile-info__bonus-bar__connector {
    width: 2px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    background-color: #dee2e6;
  }

  .profile-info__bonus-bar__content {
    margin-left: 15px;
  }

  .profile-info__bonus-bar__content-title {
    font-style: normal;
    color: #7d7e7d;
  }

  .profile-info__bonus-bar__content-info {
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    color: #7d7e7d;
  }

  .profile-info__bonus-bar__cashback {
    margin-left: auto;
    margin-right: 0;
    font-style: normal;
    color: #7d7e7d;
  }

  .active-status {
    font-weight: bold;
    color: black;
  }
}

@media screen and (min-width: 1025px) {
  .profile {
    max-width: 1260px;
    justify-self: center;
  }

  .profile-wrapper {
    display: flex;
    justify-content: space-between;
    margin-left: auto;
    margin-right: auto;
    padding: 0 10px;
  }

  .profile-text {
    margin-left: 20px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
  }

  .profile-info {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 18px;
    width: 100%;
    background: #ffffff;
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    padding-bottom: 15px;
  }

  .profile-info__login {
    margin: 10px 0 0 20px;
  }

  .profile-info__login-head {
    display: block;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #939090;
  }

  .profile-info__login-login {
    margin-top: 15px;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
  }

  .profile-info__bonus-section {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 18px;
    width: 100%;
    background: #ffffff;
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    padding-bottom: 15px;
  }

  .profile-info__bonus {
    margin: 10px 0 0 20px;
  }

  .profile-info__bonus-head {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #939090;
  }

  .profile-info__bonus-info {
    margin-top: 15px;
    margin-right: 15px;
    display: flex;
    justify-content: space-between;
  }

  .profile-info__bonus-info__score {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
  }

  .profile-info__bonus-info__status {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #3d9c1c;
  }

  .profile-info__bonus-bar {
    margin: 20px 15px 0 0;
    min-height: 50px;
  }

  .profile-info__bonus-desc {
    display: flex;
    margin-top: 25px;
    align-items: center;
  }

  .profile-info__bonus-desc__link {
    text-decoration: none;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }

  .profile-info__bonus-desc__icon {
    margin: 0 0 0 5px;
  }

  .profile-subscribe {
    overflow: hidden;
    margin-top: 20px;
    background: #ffffff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
  }

  .profile-subscribe__text {
    display: block;
    margin: 14px 0 0 20px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #939090;
  }

  .profile-subscribe__form {
    margin: 15px 0 0 20px;
  }
  .profile-subscribe__form-wrapper {
    display: flex;
    align-items: center;
  }

  .profile-subscribe__form-text {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
  }

  .profile-subscribe__form-check {
    margin: 2px 0 0 12px;
  }

  .profile-subscribe__form-btn__submit {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    background-color: #2196f3;
    color: #ffffff;
    border: none;
    border-radius: 4px !important;
    padding: 10px 26px;
    overflow: hidden;
    margin: 15px 0 15px 0 !important;
  }


  .profile-info__bonus-bar__status {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    color: rgb(148, 148, 148);

    margin: 0 0 15px 0;
  }

  .profile-info__titles {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    margin-right: 20px;
  }

  .profile-info__titles-status {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
  }

  .profile-info__titles-cashback {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
  }

  .profile-info__bonus-bar__wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    min-height: 70px;
  }

  .profile-info__bonus-bar__separator {
    -webkit-box-flex: 0;
    -ms-flex: 0;
    flex: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .profile-info__bonus-bar__marker {
    border: 2px solid #2196f3;
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
    background-color: #ffffff;
  }

  .filled__blue {
    background-color: #2196f3;
  }

  .profile-info__bonus-bar__connector {
    width: 2px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    background-color: #dee2e6;
  }

  .profile-info__bonus-bar__content {
    margin-left: 15px;
  }

  .profile-info__bonus-bar__content-title {
    font-style: normal;
    font-size: 18px;
    color: #7d7e7d;
  }

  .profile-info__bonus-bar__content-info {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #7d7e7d;
  }

  .profile-info__bonus-bar__cashback {
    margin-left: auto;
    margin-right: 0;
    font-style: normal;
    color: #7d7e7d;
  }

  .active-status {
    font-weight: bold;
    font-size: 18px;
    color: black;
  }
}
</style>
